import { Sparkles, Twitter, Facebook, Instagram, Linkedin } from "lucide-react";
import { ShareButton } from "@/components/ui/share-button";
import { Button } from "@/components/ui/button";

export function SuccessState() {
  return (
    <div className="space-y-6">
      <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
        <Sparkles className="w-8 h-8 text-green-400" />
      </div>

      <div>
        <h2 className="text-2xl font-semibold text-white mb-3">
          You're on the list!
        </h2>
        <p className="text-white/70 leading-relaxed">
          Thank you for joining our early access list. We'll send you an
          exclusive invitation when PayStreem launches.
        </p>
      </div>

      {/* Tell a Friend Share Section - After subscription */}
      <div className="bg-white/10 rounded-lg p-4 border border-white/20">
        <h3 className="text-white/90 text-lg font-semibold mb-3">
          Tell a Friend
        </h3>
        <p className="text-white/60 text-sm mb-4">
          Share PayStreem with your friends and help us build the future of
          music streaming together.
        </p>
        <div className="flex justify-center">
          <ShareButton
            url="https://www.paystreem.com"
            title="PayStreem - The Future of Music Streaming"
            text="🎵 Something amazing is coming to music streaming! PayStreem is launching soon - a revolutionary platform that connects artists, fans, and sponsors. Join the waitlist now!"
            variant="outline"
            className="bg-white/10 border-white/20 text-white hover:bg-white/20"
          />
        </div>
      </div>

      <div className="bg-white/10 rounded-lg p-4 border border-white/20">
        <p className="text-white/80 text-sm mb-3">
          Follow us on social media for updates and behind-the-scenes content as
          we build the future of music streaming.
        </p>
        <div className="flex justify-center space-x-4">
          <Button
            variant="ghost"
            size="icon"
            className="rounded-full bg-white/10 hover:bg-white/20"
          >
            <Twitter className="h-5 w-5 text-white" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="rounded-full bg-white/10 hover:bg-white/20"
          >
            <Facebook className="h-5 w-5 text-white" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="rounded-full bg-white/10 hover:bg-white/20"
          >
            <Instagram className="h-5 w-5 text-white" />
          </Button>
          <Button
            variant="ghost"
            size="icon"
            className="rounded-full bg-white/10 hover:bg-white/20"
          >
            <Linkedin className="h-5 w-5 text-white" />
          </Button>
        </div>
      </div>
    </div>
  );
}
